import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconQuestionComponent } from "./med-icon-question.component";

@NgModule({
  declarations: [
    MedIconQuestionComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconQuestionComponent,
  ],
})
export class MedIconQuestionModule { }
